export const ON_REACH_END_BOUNCE_DISTANCE = 50;
import { ConversationInboxEnum } from "@aichat/types/enums/index";
import { UserRoundCheck } from "lucide-react";
import { MdOutlineInbox } from "react-icons/md";

export const INBOX_LIST = [
  {
    label: "All",
    value: ConversationInboxEnum.ALL,
    icon: MdOutlineInbox,
  },
  // {
  //   label: "Unread",
  //   value: ConversationInboxEnum.UNREAD,
  //   icon: Mail,
  // },
  {
    label: "Live Chats",
    value: ConversationInboxEnum.ASSIGNED_TO_YOU,
    icon: UserRoundCheck,
  },
  // {
  //   label: "Unassigned",
  //   value: ConversationInboxEnum.UNASSIGNED,
  //   icon: CircleHelp,
  // },
  // {
  //   label: "Resolved",
  //   value: ConversationInboxEnum.RESOLVED,
  //   icon: PiCheckFatLight,
  // },
];

export const acceptedConversationFileExt = {
  "image/*": [".jpg", ".jpeg", ".png", ".gif"],
  "video/*": [".mp4", ".mov", ".avi", ".webm", ".mkv"],
  "application/*": [
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    ".txt",
    ".csv",
  ],
};
